import { useStream } from '@ardoq/rxbeach';
import { userOptions$ } from 'scopeData/editors/user/userOptions$';
import { List } from '../List';
import { ListEditorProps } from 'scopeData/editors/types';

// `useStream` with an empty-options default renders the Select synchronously on
// first render, whereas `connect` would defer rendering until userOptions$
// emits. The parent needs the Select mounted immediately to focus and open it
// when editing starts.
const User = (props: Omit<ListEditorProps, 'options'>) => {
  const { options } = useStream(userOptions$, { options: [] });
  return <List {...props} options={options} />;
};

export { User };
